import axios from 'axios';
import { BAD_REQUEST, CommonRequest, CommonResult, INTERNAL_SERVER_ERROR, OK, ConditionItem } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

const endpoint = process.env.REACT_APP_API_URL;
const URL = `${endpoint}/summary`;

export interface SummaryApiRequest extends CommonRequest {}

interface SummaryNumber {
  negotiationTotal: number;
  customerTotal: number;
  noneNegotiation: number;
  noneProduct: number;
  doing: number;
  pending: number;
  done: number;
  customerDoing: number;
  customerPending: number;
  customerDone: number;
}

export interface SearchCondition {
  searchCondition: {
    searchConditionId: number;
    searchConditionName: string;
    searchBranch: ConditionItem[];
  };
  summaryNumber: SummaryNumber;
}

export interface SummaryApiResponse {
  result: CommonResult;
  searchConditionResult?: SearchCondition[];
}

/**
 * 商談ステータス別件数取得API
 * @param request リクエスト
 */
export async function summaryApi(request: SummaryApiRequest): Promise<SummaryApiResponse> {
  try {
    console.log('summaryAPI', URL);
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axios.post<SummaryApiResponse>(URL, request, { headers });
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      case BAD_REQUEST.status:
        return data;
      case INTERNAL_SERVER_ERROR.status:
        throw new Error(data.result.resultCd);
      default:
        throw new Error('9999');
    }
  } catch (error) {
    return {
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG} エラーコード:${error.message}`,
          },
        ],
      },
    };
  }
}
